import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {FlowComponentsPanel} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/components/FlowComponentsPanel';
import {FlowTopBarAddButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/buttons/FlowTopBarAddButton';
import {FlowTopBarBackButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/buttons/FlowTopBarBackButton';
import {FlowTopBarPropertiesButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/buttons/FlowTopBarPropertiesButton';
import {FlowTopBarRunButton} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/buttons/FlowTopBarRunButton';
import {FlowSwitcher} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/topBar/FlowSwitcher';
import {TopBarSeparator} from '@mintdata-wsp/wsp/ui/views/visualDesigner/topBar/TopBarSeparator';
import {WonderBar} from '@mintdata-wsp/wsp/ui/views/visualDesigner/wonderBar/WonderBar';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./FlowTopBar.less');
const cx = classnames.bind(styles);

@observer
export class FlowTopBar extends React.Component<any, any>
{
    private _renderLeftBar():JSX.Element
    {
        const {sampleDesign} = rootState.ui.visualDesigner;

        const isVisibleBackButton = !sampleDesign || sampleDesign.canSwitchToFlow;

        return (
            <div className={cx('leftBar')}>
                {
                    isVisibleBackButton &&
                    <div className={cx('barButton')}>
                        <FlowTopBarBackButton />
                    </div>
                }
                {
                    isVisibleBackButton &&
                    <TopBarSeparator />
                }
                <FlowSwitcher />
            </div>
        );
    }

    private _renderMiddleBar():JSX.Element
    {
        const {flowTopBar} = controllers.ui;

        return (
            <div className={cx('middleBar')}>
                <div className={cx('addButtonWrapper')}>
                    <FlowTopBarAddButton />

                    <WonderBar
                        isVisible={flowTopBar.isWonderBarVisible()}
                        onRef={(ref:HTMLElement | null) => flowTopBar.setWonderBarDomRef(ref)}
                    >
                        <FlowComponentsPanel />
                    </WonderBar>
                </div>
            </div>
        );
    }

    private _renderRightBar():JSX.Element
    {
        const {sampleDesign} = rootState.ui.visualDesigner;

        return (
            <div className={cx('rightBar')}>
                <FlowTopBarPropertiesButton />
                {
                    !sampleDesign &&
                    <FlowTopBarRunButton />
                }
            </div>
        );
    }

    render():JSX.Element
    {
        return (
            <div className={cx('base')}>
                {this._renderLeftBar()}
                {this._renderMiddleBar()}
                {this._renderRightBar()}
            </div>
        );
    }
}
